module.exports = __webpack_public_path__ + "static/media/日历12@2x.e391ad9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_145/img/日历12@2x.png
// module id = 1385
// module chunks = 0